export const ERRORS = {
  BAD_REQUEST: 400,
  CONFLICT: 409,
  ERR_NETWORK: 'ERR_NETWORK',
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  UNPROCESSABLE_ENTITY: 422,
};
